import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=68662d9c&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=68662d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68662d9c",
  null
  
)

export default component.exports